import React from 'react';
import moment     from 'moment';
import DatePicker from 'react-datepicker';
require('react-datepicker/dist/react-datepicke.css');

const renderDatePicker = ({label,input,habilitar,minData,placeholder, defaultValue, meta: {touched, error} }) => (

  <div>
     <div className="form-group">
        <label className="control-label">{label}</label>
        <DatePicker 
                    {...input} 
                    readOnly
                    dateFormat = "DD/MM/YYYY"
                    disabled   = { habilitar ? true : false }
                    locale     = "pt-br"
                    minDate    = { minData ? minData : null }
                    selected   = { input.value ? moment(input.value, 'DD-MM-YYYY') : null }
                    className  = "form-control"/>
        {touched && error && <span className="text-danger">{error}</span>}
      </div>
  </div>
);

export default renderDatePicker;



// WEBPACK FOOTER //
// ./src/container/renderDatePicker.js